module.exports = __webpack_public_path__ + "media/components/assets/img/bg/clouds-b0bfa3a6e892a7109836aea61f7dc260.svg";